import type { ForwardedRef } from "react";

export const mergeRefs = <TElement extends HTMLElement>(...refs: Array<ForwardedRef<TElement>>) => {
	return (node: TElement | null) => {
		for (const ref of refs) {
			if (typeof ref === "function") {
				ref(node);
			} else if (ref) {
				ref.current = node;
			}
		}
	};
};
